import { query } from "../_generated/server";
import { v } from "convex/values";

export const getPostById = query({
  args: { postId: v.id("posts") },
  handler: async (ctx, args) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated");
    }
    
    const post = await ctx.db.get(args.postId);
    if (!post || post.userId !== identity.subject) {
      return null;
    }
    return post;
  },
});

export const getForCurrentUser = query({
  args: {},
  handler: async (ctx) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated call to getForCurrentUser");
    }
    
    return await ctx.db
      .query("posts")
      .withIndex("by_userId", (q) => q.eq("userId", identity.subject))
      .order("desc", "createdAt")
      .collect();
  },
});